import { Trash2 } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button, Field, Input, Modal } from "./ui";

type Props = { count: number; label: string; endpoint: string; payload: (reason: string) => any; onDone: () => void; onClear: () => void; testPrefix: string; title: string; text: string; actionLabel?: string; withReason?: boolean };

export function BulkBar({ count, label, endpoint, payload, onDone, onClear, testPrefix, title, text, actionLabel = "Hapus yang ditandai", withReason = true }: Props) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  if (count === 0) return null;
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(endpoint, payload(reason));
      toast.success(`${data.deleted} ${label} diproses${data.skipped?.length ? `, ${data.skipped.length} dilewati` : ""}.`, { duration: 8000 });
      if (data.skipped?.length) toast.info(data.skipped.map((s: any) => `${s.receipt_no || s.number || s.internal_id || ""} ${s.name || ""}: ${s.reason}`).join(" · "), { duration: 10000 });
      setOpen(false); setReason(""); onClear(); onDone();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <>
      <div className="mb-2 flex flex-wrap items-center gap-3 rounded-md border border-red-200 bg-red-50 dark:bg-red-950/20 px-3 py-2 text-sm" data-testid={`${testPrefix}-bulk-bar`}>
        <span className="font-semibold">{count} {label} ditandai</span>
        <Button variant="danger" size="sm" onClick={() => setOpen(true)} data-testid={`${testPrefix}-bulk-delete-button`}><Trash2 className="h-4 w-4" /> {actionLabel}</Button>
        <button type="button" className="text-xs underline text-muted-foreground" onClick={onClear} data-testid={`${testPrefix}-bulk-clear`}>Batal tandai</button>
      </div>
      <Modal open={open} onClose={() => setOpen(false)} title={title} testId={`${testPrefix}-bulk-confirm`}>
        <div className="space-y-3 text-sm">
          <p className="text-red-700 dark:text-red-300 font-semibold">{text}</p>
          {withReason && <Field label="Alasan (dicatat di audit trail)"><Input data-testid={`${testPrefix}-bulk-reason`} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="mis. salah input massal" /></Field>}
          <div className="flex justify-end gap-2"><Button type="button" variant="outline" onClick={() => setOpen(false)}>Batal</Button><Button type="button" variant="danger" disabled={busy} data-testid={`${testPrefix}-bulk-confirm-button`} onClick={go}>{busy ? "Memproses…" : "Ya, lanjutkan"}</Button></div>
        </div>
      </Modal>
    </>
  );
}
